import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from 'environments/environment';
import {
    normalizeModuleCode,
    resolveSingleModuleSurface,
    SINGLE_MODULE_DASHBOARD_CODES,
} from 'app/shared/entitlement/module-nav.config';
import { STORE_ADMIN_HOME } from 'app/shared/entitlement/store-admin-paths.util';

/** Module code → its landing route (defaults to `/<code>`). */
const MODULE_HOME: Record<string, string> = {
    store: STORE_ADMIN_HOME,
    mailing: '/mailing',
    campaign: '/campaigns',
};

/**
 * On a single-module surface (e.g. a Store-only / Outmailer-only tenant) the
 * generic Dashboard is meaningless — send the user straight to the module home
 * so the admin behaves as a focused single-purpose app.
 */
export const singleModuleSurfaceRedirectGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
    const branchModules = (environment.selection?.branch as { modules?: string[] } | undefined)?.modules ?? null;
    const moduleCode = resolveSingleModuleSurface(branchModules);
    if (!moduleCode) {
        return true;
    }

    const normalized = normalizeModuleCode(moduleCode);
    if (SINGLE_MODULE_DASHBOARD_CODES.has(normalized)) {
        return true;
    }

    const url = (state.url.split('?')[0].replace(/\/$/, '') || '/');
    if (url !== '/dashboard') {
        return true;
    }

    const router = inject(Router);
    const home = MODULE_HOME[normalized] ?? MODULE_HOME[moduleCode] ?? `/${normalized}`;
    return router.parseUrl(home);
};
